import { createSlice } from "@reduxjs/toolkit";
import { RoleResponseDto } from "../../shared/dtos/role/RoleResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

const roleSlice = createSlice({
  name: "role",
  initialState: getInitialCrudState<RoleResponseDto>(),
  reducers: { ...generateCrudReducers<RoleResponseDto>() },
});

export const roleActions = roleSlice.actions;
export default roleSlice.reducer;
